import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * "Volver" que se comporta como el atrás del navegador: devuelve al listado del que se vino,
 * sea el unificado (/tramites) o el propio del área (/rti/tramites, /art/tramites), sin que
 * cada ficha tenga que adivinar de dónde la abrieron.
 *
 * Cuando no hay a dónde volver —la ficha se abrió por link pegado, F5 sobre la URL, o es la
 * primera pantalla de la sesión— React Router marca esa entrada con `location.key === 'default'`
 * y ahí se cae a `rutaPorDefecto`.
 *
 * El default es el listado unificado porque los módulos previsionales nuevos (Jubilación, PUAM,
 * Plan de Pago, Reajuste, Reconocimiento, PNC, Amparo PNC) NO tienen listado propio: sus rutas
 * `/<modulo>/tramites` nunca se definieron en App.js, así que navegar ahí caía en el catch-all
 * `path="*"` y terminaba en /home. RTI y ART sí tienen el suyo y lo pasan explícito.
 */
export default function useVolverAtras(rutaPorDefecto = '/tramites') {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(() => {
        if (location.key && location.key !== 'default') {
            navigate(-1);
            return;
        }
        navigate(rutaPorDefecto);
    }, [navigate, location.key, rutaPorDefecto]);
}
